import MedicationRange from './MedicationRange.jsx';

export default MedicationRange;